module.exports = __webpack_public_path__ + "img/partners2.c9c261e0.png";